// Date 2020-10-27 09:31:32

import emEntityListView from "@/components/em/EmEntity/ListView";
import emEntityEditView from "@/components/em/EmEntity/EditView";

import SithMesQualityInspectTaskList from "@/views/sithMes/quality/SithMesQualityInspectTaskList"
import sithMesQualityInspectTemplateAddView
    from "@/views/sithMes/quality/inspectTemplate/SithMesQualityInspectTemplateAddView"
import sithMesQualityInspectTemplateSingleView
    from "@/views/sithMes/quality/inspectTemplate/SithMesQualityInspectTemplateSingleView"
import sithMesQualityInspectTemplateList
    from "@/views/sithMes/quality/inspectTemplate/SithMesQualityInspectTemplateList"
import sithMesNcrProcessTaskTask from "@/views/sithMes/quality/SithMesNcrProcessTaskTask";
import sithMesNcrProcessTaskEdit from "@/views/sithMes/quality/SithMesNcrProcessTaskEdit";
import sithMesNcrProcessTaskList from "@/views/sithMes/quality/SithMesNcrProcessTaskList";
import sithMesQualityToolBorrowRecordTask from "@/views/sithMes/quality/SithMesQualityToolBorrowRecordTask.vue";
import sithMesQualityToolBorrowRecordEdit from "@/views/sithMes/quality/SithMesQualityToolBorrowRecordEdit.vue";
import sithMesQualityToolBorrowRecordList from "@/views/sithMes/quality/SithMesQualityToolBorrowRecordList.vue";
import sithMesQualityToolManageList from "@/views/sithMes/quality/SithMesQualityToolManageList.vue";
import sithMesQualityToolManageEdit from "@/views/sithMes/quality/SithMesQualityToolManageEdit.vue";
import sithMesQualityToolCheckResultEdit from "@/views/sithMes/quality/SithMesQualityToolCheckResultEdit.vue";
import sithMesQualityToolCheckResultList from "@/views/sithMes/quality/SithMesQualityToolCheckResultList.vue";
import sithMesQualityToolScrapTask from "@/views/sithMes/quality/SithMesQualityToolScrapTask.vue";
import sithMesQualityToolScrapEdit from "@/views/sithMes/quality/SithMesQualityToolScrapEdit.vue";
import sithMesQualityToolScrapList from "@/views/sithMes/quality/SithMesQualityToolScrapList.vue";
import sithMesNcrTaskNccList from "@/views/sithMes/quality/SithMesNcrTaskNccList";
import sithMesNcrTaskNccEdit from "@/views/sithMes/quality/SithMesNcrTaskNccEdit";
import sithMesQualityInspectTaskEdit from "@/views/sithMes/quality/SithMesQualityInspectTaskEdit";
import sithMesQualityInspectCommonTemplateEdit from "@/views/sithMes/quality/SithMesQualityInspectCommonTemplateEdit";
import sithMesQualityInspectCommonTemplateList from "@/views/sithMes/quality/SithMesQualityInspectCommonTemplateList";
// import SithMesQualityDocument from "@/views/sithMes/quality/SithMesQualityDocument";
import sithMesQualityDocumentList from "@/views/sithMes/quality/SithMesQualityDocumentList.vue";
import sithMesQualityDocumentEdit from "@/views/sithMes/quality/SithMesQualityDocumentEdit.vue";
import emStocktakingTaskQualityList from "@/views/em/archive/EmStocktakingTaskList.vue";
import emStocktakingTaskQualityEdit from "@/views/em/archive/EmStocktakingTaskEdit.vue";
import emStocktakingTaskDetailQualityList from "@/views/em/archive/EmStocktakingTaskDetailList.vue";
import emStocktakingTaskDetailQualityEdit from "@/views/em/archive/EmStocktakingTaskDetailEdit.vue";


const metaObject = {requiresAuth: true, roles: ['mmf']};

export default [
//公用组件注册
    {
        path: "/sithMes/quality/sithMesQualityKpiPassRate/list",
        name: "sithMesQualityKpiPassRateList",
        component: emEntityListView,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/sithMes/quality/sithMesQualityKpiPassRate/edit",
        name: "sithMesQualityKpiPassRateEdit",
        component: emEntityEditView,
        meta: metaObject
    },
    {
        path: "/sithMes/quality/sithMesQualityInspectTaskEdit",
        name: "sithMesQualityInspectTaskEdit",
        component: sithMesQualityInspectTaskEdit,
        props: (route) => ({ prop_inline: route.query.inline }),
        meta: metaObject
    },
    {
        path: "/sithMes/quality/sithMesQualityInspectTemplate/edit",
        name: "sithMesQualityInspectTemplateEdit",
        component: emEntityEditView,
        meta: metaObject
    },
    {
        path: "/sithMes/quality/sithMesQualityInspectTemplateData/list",
        name: "sithMesQualityInspectTemplateDataList",
        component: emEntityListView,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/sithMes/quality/sithMesQualityInspectTemplateData/edit",
        name: "sithMesQualityInspectTemplateDataEdit",
        component: emEntityEditView,
        meta: metaObject
    },
    {
        path: "/sithMes/quality/sithMesQualityInspectType/list",
        name: "sithMesQualityInspectTypeList",
        component: emEntityListView,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/sithMes/quality/sithMesQualityInspectType/edit",
        name: "sithMesQualityInspectTypeEdit",
        component: emEntityEditView,
        meta: metaObject
    },
    {
        path: "/sithMes/quality/sithMesNcrTaskNccItem/list",
        name: "sithMesNcrTaskNccItemList",
        component: emEntityListView,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/sithMes/quality/sithMesNcrTaskNccItem/edit",
        name: "sithMesNcrTaskNccItemEdit",
        component: emEntityEditView,
        meta: metaObject
    },
//自定义页面注册
    {
        path: "/sithMes/quality/sithMesQualityInspectTaskIncoming",
        name: "sithMesQualityInspectTaskIncomingList",
        component: SithMesQualityInspectTaskList,
        props: () => ({customVuexName: 'sithMesQualityInspectTaskIncoming'}),
        meta: metaObject
    },
    {
        path: "/sithMes/quality/sithMesQualityInspectTaskProcess",
        name: "sithMesQualityInspectTaskProcessList",
        component: SithMesQualityInspectTaskList,
        props: () => ({customVuexName: 'process'}),
        meta: metaObject
    },
    {
        path: "/sithMes/quality/sithMesQualityInspectTaskEnd",
        name: "sithMesQualityInspectTaskFinalList",
        component: SithMesQualityInspectTaskList,
        props: () => ({customVuexName: 'sithMesQualityInspectTaskEnd'}),
        meta: metaObject
    },
    {
        path: "/sithMes/quality/sithMesQualityInspectTaskReturnStock",
        name: "sithMesQualityInspectTaskReturnStock",
        component: SithMesQualityInspectTaskList,
        props: () => ({customVuexName: 'sithMesQualityInspectTaskReturnStock'}),
        meta: metaObject
    },
    {
        path: "/sithMes/quality/sithMesQualityInspectTaskOutsource",
        name: "sithMesQualityInspectTaskOutsourceList",
        component: SithMesQualityInspectTaskList,
        props: () => ({customVuexName: 'sithMesQualityInspectTaskOutsource'}),
        meta: metaObject
    },
    {
        path: "/sithMes/quality/sithMesQualityInspectTemplate/saveTemplate",
        name: "SithMesQualityInspectTemplateAddView",
        component: sithMesQualityInspectTemplateAddView
    },
    {
        path: "/sithMes/quality/sithMesQualityInspectTemplateSingleView",
        name: "SithMesQualityInspectTemplateSingleView",
        component: sithMesQualityInspectTemplateSingleView
    },
    {
        path: "/sithMes/quality/sithMesQualityInspectTemplate/list",
        name: "sithMesQualityInspectTemplateList",
        component: sithMesQualityInspectTemplateList,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/sithMes/quality/sithMesQualityToolManageList",
        name: "sithMesQualityToolManageList",
        component: sithMesQualityToolManageList,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/sithMes/quality/sithMesQualityToolManageEdit",
        name: "sithMesQualityToolManageEdit",
        component: sithMesQualityToolManageEdit,
        meta: metaObject
    },
    {
        path: "/sithMes/quality/sithMesQualityToolBorrowRecordEdit",
        name: "sithMesQualityToolBorrowRecordEdit",
        component: sithMesQualityToolBorrowRecordEdit,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/sithMes/quality/sithMesQualityToolBorrowRecordTask",
        name: "sithMesQualityToolBorrowRecordTask",
        component: sithMesQualityToolBorrowRecordTask,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/sithMes/quality/sithMesQualityToolBorrowRecordList",
        name: "sithMesQualityToolBorrowRecordList",
        component: sithMesQualityToolBorrowRecordList,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/sithMes/quality/sithMesQualityToolCheckResultEdit",
        name: "sithMesQualityToolCheckResultEdit",
        component: sithMesQualityToolCheckResultEdit,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/sithMes/quality/sithMesQualityToolCheckResultList",
        name: "sithMesQualityToolCheckResultList",
        component: sithMesQualityToolCheckResultList,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/sithMes/quality/sithMesQualityToolScrapTask",
        name: "sithMesQualityToolScrapTask",
        component: sithMesQualityToolScrapTask,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/sithMes/quality/sithMesQualityToolScrapEdit",
        name: "sithMesQualityToolScrapEdit",
        component: sithMesQualityToolScrapEdit,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/sithMes/quality/sithMesQualityToolScrapList",
        name: "sithMesQualityToolScrapList",
        component: sithMesQualityToolScrapList,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/sithMes/quality/sithMesNcrProcessTaskTask",
        name: "sithMesNcrProcessTaskTask",
        component: sithMesNcrProcessTaskTask,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/sithMes/quality/sithMesNcrProcessTaskEdit",
        name: "sithMesNcrProcessTaskEdit",
        component: sithMesNcrProcessTaskEdit,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/sithMes/quality/sithMesNcrProcessTaskList",
        name: "sithMesNcrProcessTaskList",
        component: sithMesNcrProcessTaskList,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/sithMes/quality/sithMesNcrTaskNccList",
        name: "sithMesNcrTaskNccList",
        component: sithMesNcrTaskNccList,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/sithMes/quality/sithMesNcrTaskNccEdit",
        name: "sithMesNcrTaskNccEdit",
        component: sithMesNcrTaskNccEdit,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/sithMes/quality/sithMesQualityInspectCommonTemplateEdit",
        name: "sithMesQualityInspectCommonTemplateEdit",
        component: sithMesQualityInspectCommonTemplateEdit,
        props: (route) => ({ prop_inline: route.query.inline }),
        meta: metaObject
    },
    {
        path: "/sithMes/quality/sithMesQualityInspectCommonTemplateList",
        name: "sithMesQualityInspectCommonTemplateList",
        component: sithMesQualityInspectCommonTemplateList,
        props: (route) => ({ prop_inline: route.query.inline }),
        meta: metaObject
    },
    // {
    //     path: "/sithMes/qv/qualityDocument",
    //     name: "sithMesQualityDocument",
    //     component: SithMesQualityDocument
    // },
    {
        path: "/sithMes/quality/sithMesQualityDocumentList",
        name: "sithMesQualityDocumentList",
        component: sithMesQualityDocumentList,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/sithMes/quality/sithMesQualityDocumentEdit",
        name: "sithMesQualityDocumentEdit",
        component: sithMesQualityDocumentEdit,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/sithMes/quality/emStocktakingTaskList",
        name: "emStocktakingTaskQualityList",
        component: emStocktakingTaskQualityList,
        props: (route) => ({ prop_inline: route.query.inline }),
        meta: metaObject
    },
    {
        path: "/sithMes/quality/emStocktakingTaskEdit",
        name: "emStocktakingTaskQualityEdit",
        component: emStocktakingTaskQualityEdit,
        props: (route) => ({ prop_inline: route.query.inline }),
        meta: metaObject
    },
    {
        path: "/sithMes/quality/emStocktakingTaskDetailList",
        name: "emStocktakingTaskDetailQualityList",
        component: emStocktakingTaskDetailQualityList,
        props: (route) => ({ prop_inline: route.query.inline }),
        meta: metaObject
    },
    {
        path: "/sithMes/quality/emStocktakingTaskDetailEdit",
        name: "emStocktakingTaskDetailQualityEdit",
        component: emStocktakingTaskDetailQualityEdit,
        props: (route) => ({ prop_inline: route.query.inline }),
        meta: metaObject
    }

]
